// extracted by mini-css-extract-plugin
export default {"serviceWrapper":"servicePage_serviceWrapper__LYJUM"};